var _a;
import { CURRENCY_FORMAT } from "./money";
export class StorefrontCheckoutTextUtils {
    static fillTemplateVariables({ text, currency, coveragePrice, cartTotal, }) {
        let textWithVariables = text.replaceAll("%price%", CURRENCY_FORMAT(currency || "USD").format(coveragePrice));
        textWithVariables = textWithVariables.replaceAll("%cartTotal%", CURRENCY_FORMAT(currency || "USD").format(cartTotal));
        textWithVariables = textWithVariables.replaceAll("%combinedPrice%", CURRENCY_FORMAT(currency || "USD").format(coveragePrice + cartTotal));
        return textWithVariables;
    }
    static getTextByProduct(textByProduct, { fees, hasProtectionReturnsAndSplit, cartEligibleProtection, cartEligibleReturns, currency, coveragePrice, cartTotal, }) {
        if (!textByProduct) {
            return undefined;
        }
        const { returns, packageProtection, both } = textByProduct;
        let finalText;
        if (fees.mainType === "return") {
            finalText = returns;
        }
        else if (fees.mainType === "return,package_protection") {
            finalText = both;
        }
        else if (fees.mainType === "package_protection") {
            finalText = packageProtection;
        }
        if (hasProtectionReturnsAndSplit) {
            if (cartEligibleReturns && cartEligibleProtection) {
                finalText = both;
            }
            else if (cartEligibleProtection) {
                finalText = packageProtection;
            }
            else {
                finalText = returns;
            }
        }
        if (finalText) {
            finalText = this.fillTemplateVariables({
                text: finalText,
                currency,
                coveragePrice,
                cartTotal,
            });
        }
        return finalText;
    }
    static getCoverageTextAndSubtext(coverageText, textInfo) {
        if (!coverageText) {
            return {};
        }
        const titleText = this.getTextByProduct({
            returns: coverageText.returns?.titleText,
            packageProtection: coverageText.packageProtection?.titleText,
            both: coverageText.both?.titleText,
        }, textInfo);
        const subtitleText = this.getTextByProduct({
            returns: coverageText.returns?.subtitleText,
            packageProtection: coverageText.packageProtection?.subtitleText,
            both: coverageText.both?.subtitleText,
        }, textInfo);
        return { titleText, subtitleText };
    }
}
_a = StorefrontCheckoutTextUtils;
StorefrontCheckoutTextUtils.defaultCheckoutButtonTexts = {
    titleText: "Checkout+ | %combinedPrice%",
    subtitleText: "",
};
/** Source of truth for storefront default text when the merchants' texts are empty. Also for AB test placeholders & coverage preview defaults. */
StorefrontCheckoutTextUtils.defaultCheckoutTexts = {
    coverageButtonText: {
        returns: _a.defaultCheckoutButtonTexts,
        packageProtection: _a.defaultCheckoutButtonTexts,
        both: _a.defaultCheckoutButtonTexts,
    },
    nonCoverageButtonText: {
        returns: "Checkout without free returns",
        packageProtection: "Checkout without package protection",
        both: "Checkout without free returns & package protection",
    },
    cardText: {
        returns: {
            titleText: "Checkout+",
            subtitleText: `Free returns on your order`,
        },
        packageProtection: {
            titleText: "Checkout+",
            subtitleText: "Package protection on your order",
        },
        both: {
            titleText: "Checkout+",
            subtitleText: `Free returns + package protection`,
        },
    },
};
//# sourceMappingURL=storefront-checkout-text-utils.jsx.map